import { useMemo } from 'react';
import PropTypes from 'prop-types';

import isNil from 'lodash/isNil';

import { Typography } from 'Components/Typography';

import sample from 'utils/sample';

import BlockLayout from './BlockLayout';

const ProductProTip = ({ content: proTips, productLabel }) => {
  // memo avoids sampling a new formula on re-render
  const proTip = useMemo(() => sample(proTips), [proTips]);

  return (
    <BlockLayout backgroundColor={proTip.background} contentAlign="center" direction="column">
      <Typography color="white" markupName="h2" paragraph variant="mono2">
        {(isNil(proTip.number) && proTip.question) || `${productLabel} tip #${proTip.number}`}
      </Typography>
      <Typography color="white" markupName="p" paragraph variant="h3">
        {(isNil(proTip.number) && proTip.description) || `${proTip.description}`}
      </Typography>
    </BlockLayout>
  );
};

ProductProTip.propTypes = {
  /**
   * Contains an array of protips. A protip is randomly showed.
   */
  content: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  productLabel: PropTypes.string,
};

ProductProTip.defaultProps = {
  productLabel: 'Pro',
};

export default ProductProTip;
